import ResetPasswordForm from '../Components/Forms/ResetPasswordForm'
import React from 'react'

export const ResetPassword = () => {
  return (
   <ResetPasswordForm/>
  )
}
